import {
  ICustomQuestionTypeConfiguration,
  QuestionDropdownModel,
  Serializer,
} from "survey-core";
import "./crp-pp-global-selector.css";

const QUESTION_TYPE_NAME = "crp-pp-global-selector";
const QUESTION_TITLE_IN_BUILDER = "CRP PP Global Selector";
const DEFAULT_QUESTION_TITLE = "CRP PP Global Selector";

interface ICRPPGlobalSelectorQuestion extends ICustomQuestionTypeConfiguration {}

const crpPPGlobalSelectorQuestion: ICRPPGlobalSelectorQuestion = {
  name: QUESTION_TYPE_NAME,
  title: QUESTION_TITLE_IN_BUILDER,
  defaultQuestionTitle: DEFAULT_QUESTION_TITLE,
  elementsJSON: [
    {
      type: "dropdown",
      name: "crp-pp-global-selector-unit-dropdown",
      title: "%-%tolgee:global-selection-title%-%",
      placeholder: "%-%tolgee:global-selection-unit-placeholder%-%",
      startWithNewLine: false,
      minWidth: "200px",
      width: "200px",
      maxWidth: "200px",
      searchEnabled: false,
    },
    {
      type: "text",
      name: "crp-pp-global-selector-avg-weight-in-kg-for-pieces-unit-text",
      visibleIf: "{composite.crp-pp-global-selector-unit-dropdown} = 'pieces'",
      title:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-pieces-unit-text-title%-%",
      placeholder:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-global-unit-text-placeholder%-%",
      startWithNewLine: false,
      maxWidth: "30%",
      maskType: "currency",
      maskSettings: {
        min: 0,
        suffix: " kg",
      },
    },
    {
      type: "text",
      name: "crp-pp-global-selector-avg-weight-in-kg-for-pairs-unit-text",
      visibleIf: "{composite.crp-pp-global-selector-unit-dropdown} = 'pairs'",
      title:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-pairs-unit-text-title%-%",
      placeholder:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-pairs-unit-text-placeholder%-%",
      startWithNewLine: false,
      maxWidth: "30%",
      maskType: "currency",
      maskSettings: {
        min: 0,
        suffix: " kg",
      },
    },
    {
      type: "text",
      name: "crp-pp-global-selector-avg-weight-in-kg-for-dozens-unit-text",
      visibleIf: "{composite.crp-pp-global-selector-unit-dropdown} = 'dozens'",
      title:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-dozens-unit-text-title%-%",
      placeholder:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-dozens-unit-text-placeholder%-%",
      startWithNewLine: false,
      maxWidth: "30%",
      maskType: "currency",
      maskSettings: {
        min: 0,
        suffix: " kg",
      },
    },
    {
      type: "text",
      name: "crp-pp-global-selector-avg-weight-in-kg-for-sets-unit-text",
      visibleIf: "{composite.crp-pp-global-selector-unit-dropdown} = 'sets'",
      title:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-sets-unit-text-title%-%",
      placeholder:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-sets-unit-text-placeholder%-%",
      startWithNewLine: false,
      maxWidth: "30%",
      maskType: "currency",
      maskSettings: {
        min: 0,
        suffix: " kg",
      },
    },
    {
      type: "text",
      name: "crp-pp-global-selector-avg-weight-in-kg-for-meter-unit-text",
      visibleIf: "{composite.crp-pp-global-selector-unit-dropdown} = 'meter'",
      title:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-meter-unit-text-title%-%",
      placeholder:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-meter-unit-text-placeholder%-%",
      startWithNewLine: false,
      maxWidth: "30%",
      maskType: "currency",
      maskSettings: {
        min: 0,
        suffix: " kg",
      },
    },
    {
      type: "text",
      name: "crp-pp-global-selector-avg-weight-in-kg-for-yard-unit-text",
      visibleIf: "{composite.crp-pp-global-selector-unit-dropdown} = 'yard'",
      title:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-yard-unit-text-title%-%",
      placeholder:
        "%-%tolgee:crp-pp-global-selector-avg-weight-in-kg-for-yard-unit-text-placeholder%-%",
      startWithNewLine: false,
      maxWidth: "30%",
      maskType: "currency",
      maskSettings: {
        min: 0,
        suffix: " kg",
      },
    },
  ],
  onInit: () => {
    Serializer.addProperty(QUESTION_TYPE_NAME, {
      name: "unitChoicesUrl",
      type: "string",
      default: "",
    });
  },
  onLoaded(question) {
    const unitChoicesUrl = question.getPropertyValue("unitChoicesUrl");
    const questions = question.contentPanel.getQuestions(true);
    const unitsQuestion = questions[0] as QuestionDropdownModel;
    unitsQuestion.choicesByUrl.url = unitChoicesUrl;
    unitsQuestion.choicesByUrl.valueName = "value";
    unitsQuestion.choicesByUrl.titleName = "title";
  },
};

export default crpPPGlobalSelectorQuestion;
